var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h4',{staticClass:"mt-8"},[_vm._v("Please wait! Authentication in progress...")]),_c('div',{staticStyle:{"width":"300px","margin":"0 auto"}},[_c('v-progress-linear',{staticClass:"my-4",attrs:{"indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }